/* eslint-disable no-unused-vars */
import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import Amplify, { Auth, PubSub } from 'aws-amplify'
import { AWSIoTProvider } from '@aws-amplify/pubsub'
import Location from 'aws-sdk/clients/location'
import {
  applyPolyfills,
  defineCustomElements,
} from '@aws-amplify/ui-components/loader'

import { datadogLogs } from '@datadog/browser-logs'
import router from './router'
import store from './store'
import App from './App.vue'

// Amplify
import awsExports from './aws-exports'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/vue-select'
import '@/libs/clipboard'
import '@/libs/sweet-alerts'

// Axios Mock Adapter
import '@/@fake-db/db'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

datadogLogs.init({
  clientToken: 'pubfdccb8706fad30087bae265b5ee2e549',
  site: 'datadoghq.com',
  forwardErrorsToLogs: true,
  forwardConsoleLogs: 'all',
  sessionSampleRate: 100,
})

datadogLogs.setGlobalContext({ env: process.env.VUE_APP_AMPLIFY_ENV })

Amplify.configure(awsExports)
applyPolyfills().then(() => {
  defineCustomElements(window)
})
Amplify.addPluggable(new AWSIoTProvider({
  aws_pubsub_region: 'eu-north-1',
  aws_pubsub_endpoint: 'wss://abgribfublz22-ats.iot.eu-north-1.amazonaws.com/mqtt',
}))

const createClient = async () => {
  const credentials = await Auth.currentCredentials()
  const client = new Location({
    credentials,
    region: awsExports.aws_project_region,
  })
  return client
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
